import { useState, useEffect } from 'react';
import axios from 'axios';
import { auth } from './auth';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSubscription = () => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscription();
  }, []);

  const fetchSubscription = async () => {
    try {
      const user = auth.getUser();
      if (!user) return;

      const response = await axios.get(`${API}/subscription/${user.id}`);
      setSubscription(response.data);
    } catch (error) {
      console.error('Subscription fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const canAccess = (feature) => {
    if (!subscription) return false;
    
    const freeFeatures = ['chat', 'ai_draft', 'activity', 'marketplace_cases'];
    if (freeFeatures.includes(feature)) return true;
    
    return subscription.plan === 'PRO' && ['ACTIVE', 'TRIALING'].includes(subscription.status);
  };

  const isPro = () => subscription?.plan === 'PRO';
  const isFree = () => !subscription || subscription.plan === 'FREE';

  return {
    subscription,
    loading,
    canAccess,
    isPro,
    isFree,
    refresh: fetchSubscription
  };
};
